import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { ISection, ISectionHeading, ISectionWrapper } from './types'
import { FeatureList } from './Feature'
import TwoCol from './TwoCol'
import slugify from 'slugify'
import { Callout } from '../Callout'
import { TrackedCTA } from '../TrackedCTA'
import { prepareData } from 'utils/googleData'

export const SectionHeading = ({ title, subtitle, tag }: ISectionHeading) => {
    return (
        <div className="mb-6">
            {tag && (
                <span className="bg-purple-100 dark:bg-purple-900/70 mb-6 inline-flex items-center rounded-2xl px-6 py-2.5 text-base font-medium text-purple-800 shadow-[0_2px_8px_-1px_rgba(107,70,193,0.3)] dark:text-purple-200 dark:shadow-[0_2px_8px_-1px_rgba(147,51,234,0.3)]">
                    {tag}
                </span>
            )}
            {title && (
                <h2 className="m-0 -mt-4 pt-4 text-3xl" id={slugify(title?.replace('&-', ''), { lower: true })}>
                    {title}
                </h2>
            )}
            {subtitle && typeof subtitle === 'string' ? (
                <p className="m-0 text-base font-semibold opacity-70">{subtitle}</p>
            ) : (
                subtitle
            )}
        </div>
    )
}

export const Section = (props: ISection) => {
    const {
        enable,
        title,
        subtitle,
        tag,
        features,
        image,
        imageFile,
        svgImage,
        content,
        align,
        sections,
        imgFrame,
        direction,
        className = '',
        callout,
        cta,
        gatsbyImage,
        form,
        isSecured,
    } = props
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    let transformedCallout = callout

    if (Array.isArray(transformedCallout) && transformedCallout?.length == 1) {
        transformedCallout = transformedCallout[0]
    }
    let transformedCTA = cta
    if (Array.isArray(transformedCTA) && transformedCTA?.length == 1) {
        transformedCTA = transformedCTA[0]
    }
    const imageFrame =
        imgFrame !== undefined && (typeof imgFrame === 'string' ? imgFrame !== 'false' : imgFrame !== false)

    return (
        <div dir={direction} className={className} style={{ alignSelf: align }}>
            {(title || subtitle) && <SectionHeading title={title} subtitle={subtitle} tag={tag} />}
            {content && <div dangerouslySetInnerHTML={{ __html: content }} />}
            {features && features?.length > 0 && <FeatureList features={features} />}
            {gatsbyImage && (
                <GatsbyImage
                    alt={title || ''}
                    image={gatsbyImage}
                    className={imageFrame ? 'overflow-hidden rounded shadow-xl' : ''}
                />
            )}
            {svgImage && !gatsbyImage && (
                <img
                    alt={title || ''}
                    className={imageFrame ? 'overflow-hidden rounded shadow-xl' : ''}
                    src={svgImage}
                />
            )}

            {sections &&
                (sections?.length > 1 ? (
                    <TwoCol>
                        {sections?.map((section, index) => {
                            return <Section align={section?.align} key={index} {...section} />
                        })}
                    </TwoCol>
                ) : (
                    <Section {...sections[0]} />
                ))}
            {transformedCallout && (
                <Callout
                    content={transformedCallout?.content}
                    ctaUrl={transformedCallout.ctaUrl}
                    ctaLabel={transformedCallout.ctaLabel}
                    event={transformedCallout.event}
                    eventType={transformedCallout.eventType}
                    openQuickContact={transformedCallout.openQuickContact}
                    form={form}
                    isSecured={transformedCallout.isSecured}
                    direction={direction}
                />
            )}
            {transformedCTA && (
                <div className="mt-4">
                    <TrackedCTA
                        to={transformedCTA.url || transformedCTA.ctaUrl}
                        event={{ name: transformedCTA.event, type: transformedCTA.eventType }}
                        direction={direction}
                        type={transformedCTA.type || 'primary'}
                        className={transformedCTA.className || ''}
                        openQuickContact={transformedCTA.openQuickContact}
                        form={form}
                        isSecured={transformedCTA.isSecured}
                    >
                        {transformedCTA.label || transformedCTA.ctaLabel}
                    </TrackedCTA>
                </div>
            )}
        </div>
    )
}
export default Section
